var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1932 1080",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1925.32 108.98H6.42993V969.92H1925.32V108.98Z",
    fill: "url(#paint0_linear_139_34887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.32 108.98H6.42993L31.9899 16.14C34.6199 6.61 43.2899 0 53.1699 0H1878.57C1888.46 0 1897.13 6.61 1899.75 16.14L1925.32 108.98Z",
    fill: "url(#paint1_linear_139_34887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.32 969.91H6.42993L32.0099 1063.28C34.6299 1072.83 43.2999 1079.45 53.1999 1079.45H1878.55C1888.45 1079.45 1897.13 1072.83 1899.74 1063.28L1925.32 969.91Z",
    fill: "url(#paint2_linear_139_34887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.06 109.4H66.5998C50.7106 109.4 37.8298 122.281 37.8298 138.17V941.14C37.8298 957.03 50.7106 969.91 66.5998 969.91H1865.06C1880.95 969.91 1893.83 957.03 1893.83 941.14V138.17C1893.83 122.281 1880.95 109.4 1865.06 109.4Z",
    fill: "black",
    stroke: "#221F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42993 970.42L1925.32 970.41",
    stroke: "url(#paint3_linear_139_34887)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42993 109.4L1925.32 109.39",
    stroke: "url(#paint4_linear_139_34887)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M966.25 1024.68H965.41C962.096 1024.68 959.41 1027.37 959.41 1030.68V1031.52C959.41 1034.83 962.096 1037.52 965.41 1037.52H966.25C969.564 1037.52 972.25 1034.83 972.25 1031.52V1030.68C972.25 1027.37 969.564 1024.68 966.25 1024.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1037.12 102.77H894.54C890.18 102.77 886.65 98.1901 886.65 92.5301L889.08 14.0701C889.08 8.42008 892.61 3.83008 896.97 3.83008H1037.12C1041.48 3.83008 1045.01 8.41008 1045.01 14.0701V92.5301C1045.01 98.1801 1041.48 102.77 1037.12 102.77Z",
    fill: "url(#paint5_linear_139_34887)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M965.83 80.1805C979.692 80.1805 990.93 68.9428 990.93 55.0805C990.93 41.2181 979.692 29.9805 965.83 29.9805C951.968 29.9805 940.73 41.2181 940.73 55.0805C940.73 68.9428 951.968 80.1805 965.83 80.1805Z",
    fill: "#605F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.83 75.7009C977.218 75.7009 986.45 66.4691 986.45 55.0809C986.45 43.6928 977.218 34.4609 965.83 34.4609C954.442 34.4609 945.21 43.6928 945.21 55.0809C945.21 66.4691 954.442 75.7009 965.83 75.7009Z",
    fill: "#514F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.83 68.9704C973.501 68.9704 979.72 62.7517 979.72 55.0804C979.72 47.4092 973.501 41.1904 965.83 41.1904C958.159 41.1904 951.94 47.4092 951.94 55.0804C951.94 62.7517 958.159 68.9704 965.83 68.9704Z",
    fill: "#454340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.83 62.7009C970.038 62.7009 973.45 59.2894 973.45 55.0809C973.45 50.8725 970.038 47.4609 965.83 47.4609C961.622 47.4609 958.21 50.8725 958.21 55.0809C958.21 59.2894 961.622 62.7009 965.83 62.7009Z",
    fill: "#32312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0901 81.8996L80.2001 81.8196C79.0501 81.5696 78.3201 80.4296 78.5701 79.2796L89.5901 28.6996C89.8401 27.5496 90.9801 26.8196 92.1301 27.0696L102.26 27.6896C103.41 27.9396 104.14 29.0796 103.89 30.2296L92.6301 80.2796C92.3801 81.4296 91.2401 82.1596 90.0901 81.9096V81.8996Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.36 80.7398L81.47 80.7198C80.32 80.4698 79.68 79.7298 79.93 78.5798L90.48 30.1898C90.73 29.0398 91.82 28.0598 92.97 28.3098L101.05 28.7198C102.2 28.9698 102.93 30.1098 102.68 31.2598L91.9 79.1198C91.65 80.2698 90.51 80.9998 89.36 80.7498V80.7398Z",
    fill: "#137016"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.83 81.8996L100.94 81.8196C99.7901 81.5696 99.06 80.4296 99.31 79.2796L110.33 28.6996C110.58 27.5496 111.72 26.8196 112.87 27.0696L123 27.6896C124.15 27.9396 124.88 29.0796 124.63 30.2296L113.37 80.2796C113.12 81.4296 111.98 82.1596 110.83 81.9096V81.8996Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.1 80.7398L102.21 80.7198C101.06 80.4698 100.42 79.7298 100.67 78.5798L111.22 30.1898C111.47 29.0398 112.56 28.0598 113.71 28.3098L121.79 28.7198C122.94 28.9698 123.67 30.1098 123.42 31.2598L112.64 79.1198C112.39 80.2698 111.25 80.9998 110.1 80.7498V80.7398Z",
    fill: "#0242CD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.58 81.8996L121.69 81.8196C120.54 81.5696 119.81 80.4296 120.06 79.2796L131.08 28.6996C131.33 27.5496 132.47 26.8196 133.62 27.0696L143.75 27.6896C144.9 27.9396 145.63 29.0796 145.38 30.2296L134.12 80.2796C133.87 81.4296 132.73 82.1596 131.58 81.9096V81.8996Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_139_34887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.84 80.7398L122.95 80.7198C121.8 80.4698 121.16 79.7298 121.41 78.5798L131.96 30.1898C132.21 29.0398 133.3 28.0598 134.45 28.3098L142.53 28.7198C143.68 28.9698 144.41 30.1098 144.16 31.2598L133.38 79.1198C133.13 80.2698 131.99 80.9998 130.84 80.7498V80.7398Z",
    fill: "#E18F5F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.32 81.8996L142.43 81.8196C141.28 81.5696 140.55 80.4296 140.8 79.2796L151.82 28.6996C152.07 27.5496 153.21 26.8196 154.36 27.0696L164.49 27.6896C165.64 27.9396 166.37 29.0796 166.12 30.2296L154.86 80.2796C154.61 81.4296 153.47 82.1596 152.32 81.9096V81.8996Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59 80.7398L143.7 80.7198C142.55 80.4698 141.91 79.7298 142.16 78.5798L152.71 30.1898C152.96 29.0398 154.05 28.0598 155.2 28.3098L163.28 28.7198C164.43 28.9698 165.16 30.1098 164.91 31.2598L154.13 79.1198C153.88 80.2698 152.74 80.9998 151.59 80.7498V80.7398Z",
    fill: "#A0A29E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 180,
    width: 1775,
    height: 719,
    fill: "#F0F7FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_34887",
    x: 2.42993,
    y: 965.91,
    width: 1926.89,
    height: 11.0098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_34887",
    x: 2.42993,
    y: 104.89,
    width: 1926.89,
    height: 11.0098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_139_34887",
    x: 885.65,
    y: 2.83008,
    width: 162.36,
    height: 102.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_139_34887",
    x: 75.8762,
    y: 24.2705,
    width: 30.8528,
    height: 60.5283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.439216 0 0 0 0 0.0862745 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_139_34887",
    x: 96.6162,
    y: 24.2705,
    width: 30.8528,
    height: 60.5283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.258824 0 0 0 0 0.803922 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_139_34887",
    x: 117.356,
    y: 24.2705,
    width: 30.8528,
    height: 60.5283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.882353 0 0 0 0 0.560784 0 0 0 0 0.372549 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_34887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_34887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_34887",
    x1: 59.8899,
    y1: 1062.52,
    x2: 1871.86,
    y2: 16.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3D3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#494847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4E4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#454443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#373734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#333330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#494847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4E4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#484646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#383835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#333330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_34887",
    x1: 6.42993,
    y1: 54.49,
    x2: 1925.32,
    y2: 54.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3D3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#494847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4E4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3E3E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#333330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#494847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4E4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#484646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#383835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#333330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_139_34887",
    x1: 6.42993,
    y1: 1024.68,
    x2: 1925.32,
    y2: 1024.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#333330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_139_34887",
    x1: 6.42993,
    y1: 970.42,
    x2: 1925.32,
    y2: 970.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#282526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#3A3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#585758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#818183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ACADB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#807F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_139_34887",
    x1: 6.42993,
    y1: 109.4,
    x2: 1925.32,
    y2: 109.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#282526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3A3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#585758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#818183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8F9092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#444243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2B2829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_139_34887",
    x1: 965.83,
    y1: 102.77,
    x2: 965.83,
    y2: 3.83008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#252223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#312F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#353434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#262425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#221F20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_34887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1932,
    height: 1079.45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceImage);
export default __webpack_public_path__ + "static/media/DeviceImage.2638ad4fff11f1ef3d65fdf7ab3b4112.svg";
export { ForwardRef as ReactComponent };